import { View, StyleSheet, TouchableOpacity } from "react-native";
import React, { useState, useEffect, useRef } from "react";
import Colors from "../../Resources/Color";
import { Entypo } from "@expo/vector-icons";

const ScrollButtons = ({
  scrollRef,
  lastOffsetX,
  scrollDirection,
  width = 24,
  marginTop = 0,
  onScrollStart,
  onScrollEnd,
}) => {
  /* SCROLL HELPERS */
  const animationFrame = useRef(null);
  const SCROLL_SPEED = 750; // pixels per second

  const startScroll = (direction) => {
    if (onScrollStart) onScrollStart();
    if (animationFrame.current) {
      cancelAnimationFrame(animationFrame.current);
    }
    let prevTime = performance.now();
    const step = (timestamp) => {
      const delta = timestamp - prevTime;
      prevTime = timestamp;
      lastOffsetX.current += direction * SCROLL_SPEED * (delta / 1000);
      scrollRef.current?.scrollTo({
        x: lastOffsetX.current,
        animated: false,
      });
      animationFrame.current = requestAnimationFrame(step);
    };
    animationFrame.current = requestAnimationFrame(step);
  };

  const stopScroll = () => {
    if (onScrollEnd) onScrollEnd();
    if (animationFrame.current) {
      cancelAnimationFrame(animationFrame.current);
      animationFrame.current = null;
    }
  };

  const [hovered, setHovered] = useState(false);

  const direction = scrollDirection === "right" ? 1 : -1;
  return (
    <View
      style={{
        position: "absolute",
        top: marginTop,
        [scrollDirection]: 0,
        width: width,
        bottom: 0,
        zIndex: 3,
        justifyContent: "flex-start",
        alignItems: scrollDirection === "right" ? "flex-end" : "flex-start",
      }}
    >
      <TouchableOpacity
        onMouseEnter={() => {
          setHovered(true);
          startScroll(direction);
        }}
        onMouseLeave={() => {
          setHovered(false);
          stopScroll();
        }}
        onPressIn={() => startScroll(direction)}
        onPressOut={stopScroll}
        activeOpacity={0.6}
        style={{
          width: width,
          justifyContent: "center",
          alignItems: "center",
          alignSelf: scrollDirection === "right" ? "flex-end" : "flex-start",
          height: "100%",
          outlineStyle: "none",
          outlineWidth: 0,
          outlineColor: "transparent",
        }}
      >
        <Entypo
          name={scrollDirection != "right" ? "chevron-left" : "chevron-right"}
          size={24}
          color={Colors.bubbleColor}
          style={{ opacity: hovered ? 1 : 0 }}
        />
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({});

export default ScrollButtons;
